import { Storage } from '@ionic/storage-angular';
import { ApiService } from '../services/api/api.service';
import { ROUTES } from '../services/api/api.constants';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class VersionProvider {
  constructor(
    private storage: Storage,
    private api: ApiService,
  ) { }

  async get() {    
    let base = ROUTES.version.get;
    const result = await this.api.get(base);
    if(result && result[0] && typeof result[0] == "string")
      return result[0];
    else return null
  }
}
